export default defineNuxtRouteMiddleware(() => {
  const { isAdmin } = usePermissions();
  if (!isAdmin.value) {
    return navigateTo("/");
  }
});
